import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import BreadCumb from "../../Component/BreadCumb";
import { MyContext } from "../../hooks/MyContextProvider";
import { toast } from "react-toastify";
import { getProfileDetails, updateProfile } from "../../Libs/api";
import { isValidEmail, nonNumericRegex } from "../../hooks/helper";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const Profile = () => {
  const [loading, setloading] = useState(false);
  const [inputData, setInputData] = useState({
    name: "",
    email: "",
    phoneNo: "",
    address: "",
    aboutUs: "",
    winningAward: "",
    completedProject: "",
    clientReview: "",
    teamMember: "",
    facebookLink: "",
    twitterLink: "",
    linkedinLink: "",
    instagramLink: "",
  });

  console.log("inputData: ", inputData);

  // Debug effect to track state changes
  useEffect(() => {
    console.log("inputData changed:", inputData);
  }, [inputData]);
  const [inputDataError, setInputDataError] = useState({
    name: false,
    email: false,
    phoneNo: false,
    address: false,
  });

  const callProfileAPI = useCallback(async () => {
    try {
      setloading(true);
      const apiCall = await getProfileDetails();
      console.log("API Response:", apiCall?.data);
      if (apiCall.status) {
        // Remove setTimeout to prevent race conditions
        setInputData((prevData) => {
          const newData = {
            name: apiCall?.data?.firstName || "",
            email: apiCall?.data?.email || "",
            phoneNo: apiCall?.data?.phoneNo || "",
            address: apiCall?.data?.address || "",
            aboutUs: apiCall?.data?.aboutUs || "",
            winningAward: apiCall?.data?.winningAward || "",
            completedProject: apiCall?.data?.completedProject || "",
            clientReview: apiCall?.data?.clientReview || "",
            teamMember: apiCall?.data?.teamMember || "",
            facebookLink: apiCall?.data?.facebookLink || "",
            twitterLink: apiCall?.data?.twitterLink || "",
            linkedinLink: apiCall?.data?.linkedinLink || "",
            instagramLink: apiCall?.data?.instagramLink || "",
            id: apiCall?.data?.id || "",
          };
          console.log("Setting new inputData:", newData);
          return newData;
        });
        setloading(false);
      } else {
        toast.error(apiCall?.message);
        setloading(false);
      }
    } catch (error) {
      setloading(false);
      console.log(error);
      toast.error(error);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    callProfileAPI();
  }, [callProfileAPI]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputData?.name) {
      toast.error("Please enter a name for the profile");
      setInputDataError({ ...inputDataError, name: true });
    } else if (inputData.name.length < 3) {
      toast.error("Name must contain at least 3 characters");
      setInputDataError({ ...inputDataError, name: true });
    } else if (!inputData?.email) {
      setInputDataError({ ...inputDataError, email: true });
      toast.error("Please Enter a Email");
    } else if (!isValidEmail(inputData?.email)) {
      setInputDataError({ ...inputDataError, email: true });
      toast.error("Please Enter a Email in Proper Format");
    } else if (!inputData?.phoneNo) {
      toast.error("Please enter a phone no for the profile");
      setInputDataError({ ...inputDataError, phoneNo: true });
    } else if (inputData.phoneNo.length !== 10) {
      toast.error("Phone no must contain at least 10 characters");
      setInputDataError({ ...inputDataError, phoneNo: true });
    } else if (!inputData?.address) {
      toast.error("Please enter a phone no for the profile");
      setInputDataError({ ...inputDataError, address: true });
    } else if (inputData.address.length <= 3) {
      toast.error("address must contain at least 3 characters");
      setInputDataError({ ...inputDataError, address: true });
    } else {
      setloading(true);
      try {
        const apiCall = await updateProfile(inputData);
        if (apiCall.status) {
          console.log(apiCall, "apiCall");
          toast.success("Record Updated Successfully!");
          setloading(false);
        } else {
          setloading(false);
          toast.error(apiCall?.message);
        }
      } catch (error) {
        console.log(error);
        setloading(false);
        toast.error("Something went wrong. Please try again later.");
      }
    }
  };

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["link"],
        ["clean"],
      ],
      clipboard: {
        matchVisual: false, // Prevents Quill from creating additional divs on paste
      },
    }),
    []
  );

  return (
    <div class="page-body">
      <BreadCumb title={"Profile"} subtitle={"Profile"} />
      <div class="container-fluid">
        <div class="row">
          <div class="col-xl-12">
            <form class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Name</label>
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Name"
                        value={inputData?.name}
                        onChange={(e) => {
                          if (
                            nonNumericRegex.test(e.target.value) ||
                            e.target.value === ""
                          ) {
                            setInputData({
                              ...inputData,
                              name: e.target.value,
                            });

                            if (e.target.value?.length >= 3) {
                              setInputDataError({
                                ...inputDataError,
                                name: false,
                              });
                            } else {
                              setInputDataError({
                                ...inputDataError,
                                name: true,
                              });
                            }
                          } else {
                            toast.error("Type Characters Only", {
                              toastId: "sysmbol",
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Email</label>
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Email"
                        value={inputData?.email}
                        onChange={(e) => {
                          setInputData({
                            ...inputData,
                            email: e.target.value,
                          });

                          if (
                            e.target.value?.length >= 3 &&
                            isValidEmail(e.target.value)
                          ) {
                            setInputDataError({
                              ...inputDataError,
                              email: false,
                            });
                          } else {
                            setInputDataError({
                              ...inputDataError,
                              email: true,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div class="col-sm-12  col-md-6">
                    <div class="mb-3">
                      <label class="form-label">Phone No</label>
                      <input
                        class="form-control"
                        type="number"
                        placeholder="Phone No"
                        value={inputData?.phoneNo}
                        onChange={(e) => {
                          setInputData({
                            ...inputData,
                            phoneNo: e.target.value,
                          });

                          if (e.target.value?.length === 10) {
                            setInputDataError({
                              ...inputDataError,
                              phoneNo: false,
                            });
                          } else {
                            setInputDataError({
                              ...inputDataError,
                              phoneNo: true,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="">
                      <label class="form-label">Address</label>
                    </div>
                    <textarea
                      placeholder="Address"
                      className="form-control"
                      value={inputData?.address}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          address: e.target.value,
                        });

                        if (e.target.value?.length >= 3) {
                          setInputDataError({
                            ...inputDataError,
                            address: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            address: true,
                          });
                        }
                      }}
                    ></textarea>
                  </div>

                  <div class="col-sm-12 col-md-12">
                    <div class="">
                      <label class="form-label">About Us</label>
                    </div>
                    <ReactQuill
                      key={`quill-${inputData?.id || "new"}`}
                      theme="snow"
                      modules={modules}
                      value={inputData?.aboutUs || ""}
                      onChange={(value) => {
                        console.log("ReactQuill onChange:", value);
                        setInputData((prevData) => ({
                          ...prevData,
                          aboutUs: value,
                        }));
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-5">
                    <div class="mt-2">
                      <label class="form-label">Wining Award</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Wining Award"
                      value={inputData?.winningAward}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          winningAward: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            winningAward: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            winningAward: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-5">
                    <div class="mt-2">
                      <label class="form-label">Completed Project</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Completed Project"
                      value={inputData?.completedProject}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          completedProject: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            completedProject: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            completedProject: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-5">
                    <div class="mt-2">
                      <label class="form-label">Client Review</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Client Review"
                      value={inputData?.clientReview}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          clientReview: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            clientReview: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            clientReview: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-2">
                    <div class="">
                      <label class="form-label">Team Member</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Team Member"
                      value={inputData?.teamMember}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          teamMember: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            teamMember: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            teamMember: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-2">
                    <div class="">
                      <label class="form-label">Facebook Link</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Facebook"
                      value={inputData?.facebookLink}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          facebookLink: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            facebookLink: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            facebookLink: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-2">
                    <div class="">
                      <label class="form-label">Instagram Link</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Instagram"
                      value={inputData?.instagramLink}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          instagramLink: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            instagramLink: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            instagramLink: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-2">
                    <div class="">
                      <label class="form-label">linkedin Link</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="linkedin"
                      value={inputData?.linkedinLink}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          linkedinLink: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            linkedinLink: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            linkedinLink: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="col-sm-4 col-md-4 mt-2">
                    <div class="">
                      <label class="form-label">Twitter Link</label>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Twitter"
                      value={inputData?.twitterLink}
                      onChange={(e) => {
                        setInputData({
                          ...inputData,
                          twitterLink: e.target.value,
                        });

                        if (e.target.value?.length > 0) {
                          setInputDataError({
                            ...inputDataError,
                            twitterLink: false,
                          });
                        } else {
                          setInputDataError({
                            ...inputDataError,
                            twitterLink: true,
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div class="card-footer text-end">
                <button
                  class="btn btn-primary"
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                  type="button"
                >
                  Update Profile
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
